import { render, staticRenderFns } from "./DtCopyright.vue?vue&type=template&id=4dca4ad0&scoped=true"
import script from "./DtCopyright.vue?vue&type=script&lang=js"
export * from "./DtCopyright.vue?vue&type=script&lang=js"
import style0 from "./DtCopyright.vue?vue&type=style&index=0&id=4dca4ad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca4ad0",
  null
  
)

export default component.exports